import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Service } from '@stockcare-storage/service/service';

@Component({
  standalone: false,
  selector: 'app-service-card',
  templateUrl: './service-card.component.html',
  styleUrls: ['./service-card.component.scss']
})
export class ServiceCardComponent implements OnInit {
  @Input() service: Service;
  @Output() serviceClicked = new EventEmitter<Service>();

  constructor() {}

  ngOnInit() {}

  cardClicked() {
    this.serviceClicked.emit(this.service);
  }
}
